import { render, staticRenderFns } from "./EquipmentCommunication.vue?vue&type=template&id=351fd4c8&scoped=true"
import script from "./EquipmentCommunication.vue?vue&type=script&lang=js"
export * from "./EquipmentCommunication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351fd4c8",
  null
  
)

export default component.exports